import { RELOAD_SET, RELOAD_SET_LAST } from "../actionNames";

export function setShouldReload(shouldReload) {
  return (dispatch) => {
    dispatch({
      type: RELOAD_SET,
      shouldReload,
    });
  };
}

export function setReloadDone(lastReload) {
    return (dispatch) =>
    dispatch({
      type: RELOAD_SET_LAST,
      lastReload,
    });
}
